import "@lottiefiles/lottie-player";
import { create } from "@lottiefiles/lottie-interactivity";
import { Pagination } from "swiper/modules";

// core version
import Swiper from "swiper";

(function () {
  const clinicSlider = document.querySelectorAll(
    ".products-worlds-clinic-slider"
  );
  let clinicSwiper = [];

  for (let i = 0; i < clinicSlider.length; i++) {
    clinicSwiper[i] = new Swiper(clinicSlider[i], {
      modules: [Pagination],
      loop: false,
      freeMode: true,
      slidesPerView: "auto",
      spaceBetween: 20,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        dynamicBullets: true,
      },
    });
  }

  const alllottiplayers = document.querySelectorAll(".lotti-player-clinic");

  for (let i = 0; i < alllottiplayers.length; i++) {
    let lottiplayer = document.getElementById(alllottiplayers[i].id);

    if (window.innerWidth > 1043) {
      lottiplayer.addEventListener("ready", () => {
        create({
          player: "#" + lottiplayer.id,
          mode: "cursor",
          actions: [
            {
              type: "hover",
              forceFlag: false,
            },
          ],
        });
      });
    } else {
      lottiplayer.addEventListener("ready", () => {
        create({
          player: "#" + lottiplayer.id,
          mode: "scroll",
          actions: [
            {
              visibility: [0.5, 1.0],
              type: "play",
              forceFlag: false,
            },
          ],
        });
      });
    }

    // alllottiplayers[i].addEventListener('mouseover', function(event) {
    //     event.target.play();
    // });

    // alllottiplayers[i].addEventListener('mouseout', function(event) {
    //     event.target.pause();
    // });
  }
})();
